<template>
  <div class="filter">
    <el-input
      v-model="value"
      :readonly="readonly"
      :prefix-icon="icon"
      @keyup.native="keyup"
      @clear="filter"
      clearable
      :data-qa="dataQa"
    />
  </div>
</template>

<script>
import { debounce } from 'lodash'

export default {
  name: 'RestListFilterInput',

  inject: ['restList'],

  props: {
    prop: {
      type: String,
      required: true
    },

    readonly: {
      type: Boolean,
      default: false
    },

    icon: {
      type: String,
      default: 'el-icon-search'
    },

    defaultValue: {
      required: false
    },

    filterOnEnter: {
      type: Boolean,
      default: false
    },

    dataQa: {
      type: String,
      required: false
    },

    debounceTime: {
      type: Number,
      default: 500
    },

    minChars: {
      type: Number,
      default: 0
    }
  },

  data() {
    return {
      value: null,
      lastFilteredValue: null,
      debouncedFilter: null
    }
  },

  created() {
    this.debouncedFilter = debounce(this.filter, this.debounceTime)
  },

  mounted() {
    if (this.defaultValue) {
      this.value = this.defaultValue
      this.filter()
    }
  },

  methods: {
    keyup(event) {
      if (this.filterOnEnter) {
        if (event.keyCode === 13) {
          this.debouncedFilter()
        }
      } else {
        this.debouncedFilter()
      }
    },

    filter() {
      if (this.value === this.lastFilteredValue) {
        return
      }
      if (
        this.minChars > 0 &&
        this.value &&
        this.value.length < this.minChars
      ) {
        if (this.lastFilteredValue) {
          this.restList.filterField(this.prop, null)
          this.lastFilteredValue = null
        }
        return
      }
      this.restList.filterField(this.prop, this.value)
      this.lastFilteredValue = this.value
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/common/components/rest/RestListFilterInput.vue